var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"flex-row gameplay_steps"},_vm._l((_vm.questionSteps),function(questionStep,index){return _c('div',{key:questionStep.index,class:[
        'game_step',
        {
        centered: (index > 0) &&  (index < (_vm.totalQuestions - 1)),
        correct: questionStep.answered && questionStep.correct,
        wrong: questionStep.answered && !questionStep.correct
      }]})})),_vm._v(" "),_c('div',{staticClass:"flex-row quest_count"},[_c('p',[_vm._v(_vm._s(_vm.getTranslations.game_page_header_current_question_pt1)+" "+_vm._s(_vm.currentQuestionIndex + 1)+" "+_vm._s(_vm.getTranslations.game_page_header_current_question_pt2)+" "+_vm._s(_vm.totalQuestions))]),_vm._v(" "),_vm._t("timer")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c20ac706","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/game/GameHeader.vue
// module id = null
// module chunks = 